import React from 'react';
import * as libraryService from '../../services/library/Library';

const LibraryContext = React.createContext();
const { Provider, Consumer } = LibraryContext;

class LibraryProvider extends React.Component {
  state = {
    response: null,
  };

  constructor(props) {
    super(props);
    this.storeDocument = this.storeDocument.bind(this);
    this.personDocuments = this.personDocuments.bind(this);
    this.stageDocuments = this.stageDocuments.bind(this);
    this.legalProcessActionDocuments = this.legalProcessActionDocuments.bind(
      this,
    );
    this.documentView = this.documentView.bind(this);
    this.documentDelete = this.documentDelete.bind(this);
    this.personInfo = this.personInfo.bind(this);
    this.getActionType = this.getActionType.bind(this);
    this.getDocumentTypes = this.getDocumentTypes.bind(this);
    this.userSessionExtention = this.userSessionExtention.bind(this);
  }

  async storeDocument(data) {
    return new Promise(async (resolve, reject) => {
      await libraryService
        .storeDocument(data)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  async personDocuments(documentNumber) {
    return new Promise(async (resolve, reject) => {
      await libraryService
        .personDocuments(documentNumber)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  async stageDocuments(stage, stageId, personId) {
    return new Promise(async (resolve, reject) => {
      await libraryService
        .stageDocuments(stage, stageId, personId)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
  async legalProcessActionDocuments(actionId, personId) {
    return new Promise(async (resolve, reject) => {
      await libraryService
        .legalProcessActionDocuments(actionId, personId)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  async documentView(documentId) {
    return new Promise(async (resolve, reject) => {
      await libraryService
        .documentView(documentId)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  async documentDelete(documentId) {
    return new Promise(async (resolve, reject) => {
      await libraryService
        .documentView(documentId)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  async personInfo(personId) {
    return new Promise(async (resolve, reject) => {
      await libraryService
        .personInfo(personId)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  async getActionType(actionTypeId) {
    return new Promise(async (resolve, reject) => {
      await libraryService
        .getActionType(actionTypeId)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  async getDocumentTypes(personId) {
    return new Promise(async (resolve, reject) => {
      await libraryService
        .getDocumentTypes()
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  async userSessionExtention(u, si) {
    return new Promise(async (resolve, reject) => {
      await libraryService
        .userSessionExtention(u, si)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  render() {
    const { children } = this.props;

    return (
      <Provider
        value={{
          response: this.state.response,
          storeDocument: this.storeDocument,
          personDocuments: this.personDocuments,
          stageDocuments: this.stageDocuments,
          legalProcessActionDocuments: this.legalProcessActionDocuments,
          documentView: this.documentView,
          documentDelete: this.documentDelete,
          personInfo: this.personInfo,
          getActionType: this.getActionType,
          getDocumentTypes: this.getDocumentTypes,
          userSessionExtention: this.userSessionExtention,
        }}
      >
        {children}
      </Provider>
    );
  }
}

export default LibraryContext;

export { LibraryProvider, Consumer };
